import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=6fff01a5&"
import script from "./detailed.vue?vue&type=script&lang=js&"
export * from "./detailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports